import { SelectOption } from "@models/ui-models/select-options";

export enum ShareTypeEnum {
  ORD = 'ORD',
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  K = 'K',
  L = 'L',
  M = 'M',
  N = 'N',
  O = 'O',
  EMP = 'EMP',
  FOU = 'FOU',
  LG = 'LG',
  CPS = 'GPS',
  MAN = 'MAN',
  RED = 'RED',
  SPE = 'SPE',
  PRF = 'PRF',
  CUMP = 'CUMP',
  NCP = 'NCP',
  REDP = 'REDP',
  NRP = 'NRP',
  CRP = 'CRP',
  NCRP = 'NCRP',
  PARP = 'PARP',
  DIVR = 'DIVR',
  ORDA = 'ORDA',
  ORDB = 'ORDB',
  ORD1 = 'ORD1',
  APRF = 'APRF'
}

export const shareTypeOptions: SelectOption<string>[] = Object.values(ShareTypeEnum)
  .map((type) => {
    return {
      value: type,
      label: type
    };
  });

export const companyRegistrationShareTypes = [
  ShareTypeEnum.ORD,
  ShareTypeEnum.A,
  ShareTypeEnum.B,
  ShareTypeEnum.C,
  ShareTypeEnum.D,
  ShareTypeEnum.E,
  ShareTypeEnum.F,
  ShareTypeEnum.G,
  ShareTypeEnum.H,
  ShareTypeEnum.I,
  ShareTypeEnum.J,
  ShareTypeEnum.K,
  ShareTypeEnum.L,
  ShareTypeEnum.M,
  ShareTypeEnum.N,
  ShareTypeEnum.O
];

export const companyRegistrationShareTypesOptions: SelectOption<string>[] = companyRegistrationShareTypes
  .map((type) => {
    return {
      value: type,
      label: type
    };
  });
